/**
 * @desc 事件信息
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** id */
  id: number;
}

export function request(
  params: Params,
): Promise<defs.StandardReturn<defs.GetEventByIdResponse>> {
  return defHttp.get({
    url: '/web/event/info',

    params,
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<defs.GetEventByIdResponse>> {
  return defHttp.get({
    url: '/mock/web/event/info',

    params,
  });
}
